<template>
    <aside class="mx-auto mt-10 max-w-4xl rounded-xl bg-primary-50 dark:bg-primary-950/40 p-6 md:p-8" aria-labelledby="blog-next-step-title">
        <h2 id="blog-next-step-title" class="text-xl font-bold text-gray-900 dark:text-txt-headings">{{ action.title }}</h2>
        <p class="mt-2 text-gray-700 dark:text-txt-body">{{ action.description }}</p>
        <NuxtLink
            :to="action.to"
            class="mt-4 inline-flex rounded-full bg-primary-600 px-5 py-3 font-medium text-white hover:bg-primary-700 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-600"
            @click="trackNextStep"
        >
            {{ action.label }}
        </NuxtLink>
    </aside>
</template>

<script setup lang="ts">
import type { BlogPost } from '#shared/types/Blog'
import { blogMatchesTopic } from '#shared/utils/blog'

const props = defineProps<{ post: BlogPost }>()
const { track } = useCheese()
const action = computed(() => {
    if (blogMatchesTopic(props.post, 'mentoring'))
        return {
            title: 'Posuň sa ďalej s mentorom',
            description: 'Nájdi človeka, ktorý ti pomôže s tvojou ďalšou výzvou.',
            label: 'Nájdi mentora',
            to: '/mentoring',
            topic: 'mentoring'
        }
    if (blogMatchesTopic(props.post, 'kariera'))
        return {
            title: 'Urob ďalší krok v kariére',
            description: 'Pozri si aktuálne pracovné ponuky a stáže na GROWNi.',
            label: 'Pozri prácu a stáže',
            to: '/praca',
            topic: 'kariera'
        }
    if (blogMatchesTopic(props.post, 'dobrovolnictvo'))
        return {
            title: 'Zapoj sa tam, kde môžeš pomôcť',
            description: 'Objav dobrovoľnícke príležitosti, ktoré dávajú zmysel tebe.',
            label: 'Objav dobrovoľníctvo',
            to: '/dobrovolnictvo',
            topic: 'dobrovolnictvo'
        }
    if (blogMatchesTopic(props.post, 'organizacie'))
        return {
            title: 'Rozvíjaj svoju organizáciu',
            description: 'Objav, ako ti GROWNi pomôže nájsť ľudí a nové príležitosti.',
            label: 'GROWNi pre organizácie',
            to: '/pre-organizacie',
            topic: 'organizacie'
        }
    return {
        title: 'Spoznaj svoj potenciál',
        description: 'Preskúmaj nástroje sebapoznania a nájdi svoj ďalší smer.',
        label: 'Začni sebapoznanie',
        to: '/sebapoznanie',
        topic: 'sebapoznanie'
    }
})
function trackNextStep() {
    track('blog_next_step_clicked', { blog_id: props.post.id, topic: action.value.topic, destination: action.value.to })
}
</script>
